import I18n from 'lib/i18n'
import React, { useState } from 'react'
import { useValues, useActions } from 'kea'

import Result from './result'
import FakeResult from './fake-result'
import Pagination from '~/scenes/search/search-page/pagination'
import NotFound from '~/scenes/search/search-page/not-found'

import sceneLogic from '~/scenes/search/logic'
import favouritesLogic from '../favourites-logic'

export default function Results ({ id }) {
  const { showMap, results, filter, favourites, hoverResultId, hoverLocationId, locale, dpr, isLoadingResults } =
    useValues(sceneLogic)
  const { hoverResult, translateResultRequest } = useActions(sceneLogic)

  const { settingFavourite } = useValues(favouritesLogic)
  const { setFavourite, removeFavourite } = useActions(favouritesLogic)

  const resultDivs = []

  if (isLoadingResults) {
    const count = Math.min(Math.max(3, (results.results || []).length), 25)
    for (let i = 0; i < count; i++) {
      resultDivs.push(<FakeResult key={`fake-result-${i}`} />)
    }
  } else if (results.total > 0) {
    const webcamMode = filter.location_types === 'webcam'
    const showFullLocation = webcamMode || filter.favourites
    const offset = (results.page - 1) * results.per_page
    const fuzzyWarning = filter.favourites ? -1 : results.direct - offset

    results.results.forEach((result, i) => {
      const afterFuzzyWarning = fuzzyWarning !== -1 && i >= fuzzyWarning
      if (i === fuzzyWarning) {
        resultDivs.push(
          <div key='fuzzy-warning' className='fuzzy-warning'>
            {results.page === 1 && i === 0
              ? I18n.t('main.index.extra_webcam_no_local')
              : I18n.t('main.index.extra_webcam')}
          </div>
        )
      }

      const isHovering =
        hoverResultId === result.id || (hoverLocationId && result.locations.some(l => l.id === hoverLocationId))

      resultDivs.push(
        <Result
          key={'result-' + result.id}
          result={result}
          center={filter.center}
          isHovering={isHovering}
          isFavourite={favourites.indexOf(result.id) >= 0}
          settingFavourite={settingFavourite === result.id}
          hoverResult={hoverResult}
          setFavourite={setFavourite}
          removeFavourite={removeFavourite}
          translateResultRequest={translateResultRequest}
          locale={locale}
          showFullLocation={showFullLocation || afterFuzzyWarning}
          dpr={dpr}
          score={result.score}
        />
      )
    })

    if (filter.favourites) {
      resultDivs.push(<div key='favouriteHeader' style={{ marginTop: 100 }} />)
    } else {
      resultDivs.push(<Pagination key='pagination' results={results} />)
    }
  } else {
    resultDivs.push(<NotFound key='not-found' bounds={filter.bounds} />)
  }

  return (
    <div id={id} className={`search-results ${showMap ? 'col-2-3' : 'col-1-1'}`}>
      {resultDivs}
    </div>
  )
}
